/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UndoMergeCustomerRecordsRequest
 */
export interface UndoMergeCustomerRecordsRequest {
    /**
     * 
     * @type {number}
     * @memberof UndoMergeCustomerRecordsRequest
     */
    originalCustomerId?: number;
    /**
     * 
     * @type {number}
     * @memberof UndoMergeCustomerRecordsRequest
     */
    currentCustomerId?: number;
    /**
     * 
     * @type {number}
     * @memberof UndoMergeCustomerRecordsRequest
     */
    contactId?: number;
}

/**
 * Check if a given object implements the UndoMergeCustomerRecordsRequest interface.
 */
export function instanceOfUndoMergeCustomerRecordsRequest(value: object): boolean {
    return true;
}

export function UndoMergeCustomerRecordsRequestFromJSON(json: any): UndoMergeCustomerRecordsRequest {
    return UndoMergeCustomerRecordsRequestFromJSONTyped(json, false);
}

export function UndoMergeCustomerRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndoMergeCustomerRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'originalCustomerId': json['originalCustomerId'] == null ? undefined : json['originalCustomerId'],
        'currentCustomerId': json['currentCustomerId'] == null ? undefined : json['currentCustomerId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
    };
}

export function UndoMergeCustomerRecordsRequestToJSON(value?: UndoMergeCustomerRecordsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'originalCustomerId': value['originalCustomerId'],
        'currentCustomerId': value['currentCustomerId'],
        'contactId': value['contactId'],
    };
}

